export default __webpack_public_path__ + "static/media/d26.bc59f34f.jpeg";